<template>

  <div class="page-container">
    <div class="page-container__header">
      <h1 class="header-1 page-container__title">Statisticile mele</h1>
    </div>
    <div class="page-container__body">
      <div class="stats-spacer" />

      <div class="stats-container__section">
        <div class="stats-container__chart">
          <div class="stats-card" style="max-width: 100%;">
            <h3 class="stats-card__header">
              <i class="fa fa-chart-line" />
              Vânzări totale
            </h3>
            <div class="stats-filter">
              <button :class="[
                'stats-filter__button',
                period === 'year'
                  ? 'stats-filter__button--active'
                  : ''
              ]" @click="period !== 'year' ? (period = 'year', fetchSales('year')) : null">
                An
              </button>
              <button :class="[
                'stats-filter__button',
                period === 'month'
                  ? 'stats-filter__button--active'
                  : ''
              ]" @click="period !== 'month' ? (period = 'month', fetchSales('month')) : null">
                Luna
              </button>
              <button :class="[
                'stats-filter__button',
                period === 'week'
                  ? 'stats-filter__button--active'
                  : ''
              ]" @click="period !== 'week' ? (period = 'week', fetchSales('week')) : null">
                Saptamana
              </button>
              <button :class="[
                'stats-filter__button',
                period === 'day'
                  ? 'stats-filter__button--active'
                  : ''
              ]" @click="period !== 'day' ? (period = 'day', fetchSales('day')) : null">
                Azi
              </button>

              <div class="stats-filter__filler" />
              <div class="stats-filter__credits">
                {{ coins !== null ? `${ coins }` : '...' }}
                <i class="fa fa-coins" />
              </div>
            </div>

            <p v-if="sales === null">
              Se încarcă datele...
            </p>
            <div class="chart-container" v-else>
              <ChartBar :chartData="chart" :options="{
                legend: { display: false },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [
                    {
                      ticks: {
                          min: 0
                      }
                    }
                  ],
                },
              }" />
            </div>
          </div>
        </div>
        <div class="stats-card">
          <h3 class="stats-card__header">
            Recenziile clientilor
          </h3>
          <div class="stats-card__details stats-card__details--golden">
            <i class="fa fa-star" />
            <h3 class="stats-card__text">
              {{ stats ? `${ stats.feedback_grade || 'nicio recenzie' } / 5.00` : 'Se încarcă' }}
            </h3>
          </div>
        </div>
        <div class="stats-card">
          <h3 class="stats-card__header">
            Număr de articole
          </h3>
          <div class="stats-card__details">
            <i class="fa fa-newspaper" />
            <h3 class="stats-card__text">
              {{ stats ? `${ stats.articles_count } articole scrise` : 'Se încarcă' }}
            </h3>
          </div>
        </div>
      </div>

      <div class="stats-spacer--big" />

      <Select @input="updateMonth" class="stats-selector" :initialValue="currentMonth"
        :initialOptionName="parseYearMonth(currentMonth)" :items="months" />

      <div class="stats-spacer" />

      <div class="stats-container__section">
        <div class="stats-card">
          <h3 class="stats-card__header">
            Timp petrecut
          </h3>
          <div class="stats-card__details">
            <i class="fa fa-clock" />
            <h3 class="stats-card__text" v-if="activity === null">
              Se încarcă
            </h3>
            <h3 class="stats-card__text" v-else>
              <span v-if="activity.minutes === 0 && activity.hours === 0">
                Fara timp petrecut
              </span>
              <span v-else-if="!activity.hours && activity.minutes"> 
                {{ activity.minutes }} minute
              </span>
              <span v-else-if="activity.hours && !activity.minutes">
                {{ activity.hours }} ore
              </span>
              <span v-else>
                {{ activity.hours }} ore si {{ activity.minutes }} minute
              </span>
              
            </h3>
          </div>
        </div>
        <div class="stats-card">
          <h3 class="stats-card__header">
            Număr de întâlniri
          </h3>
          <div class="stats-card__details">
            <i class="fa fa-users" />
            <h3 class="stats-card__text" v-if="activity === null">
              Se încarcă
            </h3>
            <h3 class="stats-card__text" v-else-if="activity.appointments === 0">
              Nicio întâlnirie
            </h3>
            <h3 class="stats-card__text" v-else>
              {{ activity.appointments }} întâlniri
            </h3>
          </div>
        </div>
        <div class="stats-container__money-column">
          <div class="stats-card">
            <div class="stats-card__details">
              <h3 class="stats-card__text" v-if="activity === null">
                Comision: se încarcă
              </h3>
              <h3 class="stats-card__text" v-else>
                Comision: {{ activityCommission }}%
              </h3>
            </div>
          </div>
          <div class="stats-card stats-spacer">
            <div class="stats-card__details">
              <h3 class="stats-card__text" v-if="activity === null">
                Venituri totale: se încarcă
              </h3>
              <h3 class="stats-card__text" v-else>
                Venituri totale: {{ activity.credits }}
                <i class="fa fa-coins" />
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import moment from 'moment';
  import ChartBar from '../../../components/ui/ChartBar.vue';
  import Select from '../../../components/ui/Select.vue';

  import {
    mapActions
  } from 'vuex';
  import {
    mapGetters
  } from 'vuex';

  export default {
    components: {
      ChartBar,
      Select
    },
    data() {
      return {
        period: 'month',
      };
    },
    computed: {
      /*
      monthNumber() {
        return (new Date().getMonth() + 1).toString();
      },
      */
      ...mapGetters({
        stats: 'stats/stats',
        sales: 'stats/sales',
        activity: 'stats/activity',
        coins: 'stats/coins',
      }),
      chart() {
        const labels = [];
        const values = [];

        if (this.period === 'year') {
          for (const date in this.sales.sales) {
            labels.push(this.parseYearMonth(date));
            values.push(this.sales.sales[date]);
          }
        } else if (this.period === 'month' || this.period === 'week') {
          for (const data in this.sales.sales) {
            if (this.period === 'week') {
              labels.push(moment(data, 'YYYY-MM-DD').format('dddd'));
            } else if (this.period === 'month') {
              labels.push(moment(data, 'YYYY-MM-DD').format('DD'));
            }

            values.push(this.sales.sales[data]);
          }
        } else if (this.period === 'day') {
          const dates = Object.keys(this.sales.sales);

          labels.push('Ieri');
          values.push(this.sales.sales[dates[0]]);

          labels.push('Azi');
          values.push(this.sales.sales[dates[1]]);
        }

        return {
          labels,
          datasets: [{
            label: 'Coins',
            backgroundColor: '#00BCD4',
            data: values,
            min: 0
          }]
        };
      },
      monthNames() {
        return ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie",
          "Octombrie", "Noiembrie", "Decembrie"
        ];
      },
      currentMonth() {
        return moment().format("YYYY-MM");
      },
      months() {
        if (this.stats === null) {
          return [{
            name: this.parseYearMonth(this.currentMonth),
            value: this.currentMonth
          }];
        }

        return this.stats.months.map((date) => ({
          name: this.parseYearMonth(date),
          value: date
        }));
      },

      activityCommission() {
        if (Number.isInteger(this.activity.commission))
          return this.activity.commission;
        else
          return this.activity.commission.percentage;
      }
    },
    methods: {
      ...mapActions({
        fetchStats: 'stats/fetchStats',
        fetchSales: 'stats/fetchSales',
        fetchActivity: 'stats/fetchActivity',
      }),
      parseYearMonth(date) {
        const chuck = date.split('-');
        return `${ chuck[0] }, ${ this.monthNames[parseInt(chuck[1]) - 1] }`;
      },
      updateMonth(event) {
        const chuck = event.target.value.split('-');

        this.fetchActivity({
          year: chuck[0],
          month: chuck[1],
        });
      }
    },
    mounted() {
      this.fetchStats();
      this.fetchSales('month');

      this.fetchActivity({
        year: new Date().getFullYear().toString(),
        month: (new Date().getMonth() + 1).toString(),
      });
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/scss/pages/specialist-stats";
</style>